module.exports = __webpack_public_path__ + "img/1_8_Delete.0b355323.svg";